(function() {

  em.gridTabs = {};

  var tabs = document.querySelectorAll('.the-grid-tabs [role="tab"]');

  em.gridTabs.init = function() {
    tabs.forEach(function(tab) {
      tab.addEventListener('click', em.gridTabs.changeTabs);
    });

  };

  em.gridTabs.changeTabs = function(e) {

    tabs.forEach(function(tab) {
      tab.setAttribute('aria-selected', false);
    });

    e.target.setAttribute('aria-selected', true);
  };

})();